import {render, Component, createRef } from 'preact';
import type { ComponentChildren, RefObject } from 'preact';
import Icon from './icons';
//@ts-ignore
import AutoComplete from '@tarekraafat/autocomplete.js/dist/autoComplete.js';
import '@tarekraafat/autocomplete.js/dist/css/autoComplete.02.css';
import { getLocale } from 'helpers/locale';
/**
 * @private
 */
export type AutocompleteItem = {
    name: string,
    level: string,
    id: number
}
/**
 * @private
 */
type Props = {
    placeholder: string,
    src: (value: any) => Promise<AutocompleteItem[]>,
    callbackSelect: (item?: AutocompleteItem) => void,
    keys: Array<string>,
    defaultValue?: string,
    value?: string,
    isMobileView?: boolean,
    disableAutoFocus?: boolean,
    onClose: () => void,
    clearInputOnSelection?: boolean
};
/**
 * @private
 */
type State = {};

/**
 * @private
 */
export default class Autocomplete extends Component<Props, State> {
    _inputRef: RefObject<HTMLInputElement>;
    autoCompleteJS: any;
    constructor() {
        super();

        this.componentDidMount = this.componentDidMount.bind(this);
        this.componentDidUpdate = this.componentDidUpdate.bind(this);
        this.componentWillUnmount = this.componentWillUnmount.bind(this);
        this._inputRef = createRef();
    }

    componentDidMount() {
        const {
            placeholder, src, keys, callbackSelect, defaultValue, isMobileView, disableAutoFocus, onClose, clearInputOnSelection
        } = this.props;
        const autoCompleteJS = new AutoComplete({
            debounce: 300,
            selector: () => {
                return this._inputRef.current;
            },
            placeHolder: placeholder,
            trigger: () => true,
            searchEngine: (_query: any, record: any) => {
                return record;
            },
            data: {
                src,
                keys,
            },
            resultItem: {
                tag: "li",
                element: (element: HTMLElement, data: { value: AutocompleteItem & { distance?: number; building?: string } }) => {
                    const div = document.createElement('div');
                    render(<Icon icon="stairs-thick" size={18} className='ac-results-level--icon' />, div);
                    const distance = data.value.distance !== null && data.value.distance !== undefined ? `${Math.round(data.value.distance)}m` : '';
                    element.innerHTML = data.value.building ? `<div class="ac-results-name" title="${data.value.name} - ${data.value.building}"><span class="ac-results-name--building">${data.value.building}</span><span class="ac-results-name--poi">${data.value.name}</span>${distance ? `<span class="ac-results-distance">${distance}</span>` : ''}</div><div class="ac-results-level">${div.innerHTML}<span class="ac-results-level--number">${data.value.level}</span>` : `<div class="ac-results-name" title="${data.value.name}"><span class="ac-results-name--poi" title="${data.value.name}">${data.value.name}</span>${distance ? `<span class="ac-results-distance">${distance}</span>` : ''}</div><div class="ac-results-level">${div.innerHTML}<span class="ac-results-level--number">${data.value.level}</span>`;
                },
            },
            resultsList: {
                maxResults: 11,
            },
            events: {
                input: {
                    selection: (event: CustomEvent<{ selection: { value: AutocompleteItem } }>) => {
                        const feedback = event.detail;
                        autoCompleteJS.input.blur();
                        const selection = `${feedback.selection.value.name} ${getLocale().indoor['at Level']} (${feedback.selection.value.level})`;
                        autoCompleteJS.input.value = selection;
                        if (clearInputOnSelection) autoCompleteJS.input.value = '';
                        callbackSelect(feedback.selection.value);
                    },
                    search: () => {
                        callbackSelect();
                    },
                    click() {
                        autoCompleteJS.start('');
                    },
                    change: () => {
                        callbackSelect();
                    },
                    response: (event: any) => {
                        if (event.detail && event.detail.length >= 1) {
                            setTimeout(() => {
                                autoCompleteJS.goTo(0);
                            }, 100);
                        }
                    },
                    close: () => {
                        onClose();
                    }

                },
            },
        });
        this.autoCompleteJS = autoCompleteJS;
        if (!isMobileView && !disableAutoFocus) {
            this.autoCompleteJS.input.focus();
        }

        if (defaultValue) {
            this.autoCompleteJS.input.value = defaultValue;
        } else {
            this.autoCompleteJS.input.value = '';
        }
    }
    componentDidUpdate(prevProps: Props) {
        const {value} = this.props;
        if (prevProps.value !== value) {
            this.autoCompleteJS.input.value = value;
        }
    }

    componentWillUnmount() {
        this.autoCompleteJS.unInit();
    }

    render(): ComponentChildren {
        return (
            <input
                ref={this._inputRef}
                type="search"
                dir="ltr"
                spellcheck={false}
                autoCorrect="off"
                autoComplete="off"
                autoCapitalize="off"
                maxLength={2048}
                tabIndex={1}
            />
        );
    }
}
